import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../Icon/Icon";
import "./UserApplicationDisplayItem.css";

export const UserApplicationDisplayItem = ({ app }) => {
  const { t } = useTranslation();
  const getIndicatorColor = () => {
    switch (app.type) {
      case "INVENTORY":
        return "#F4BD48";

      case "WORKFLOW":
        return "#008AC6";

      default:
        return "#008AC6";
    }
  };

  const getBaseUrl = () => {
    const uppercased = app?.type?.toUpperCase();
    return `REACT_APP_${uppercased}_URL`;
  };

  return (
    <div className="ApplicationDisplayItem">
      <div
        className="ApplicationDisplayItem__indicator"
        style={{ backgroundColor: getIndicatorColor() }}
      ></div>
      <div className="ApplicationDisplayItem__icon">
        <Icon name="menuAccounts" width={14} height={20} />
      </div>
      <div className="ApplicationDisplayItem__title">{app.name}</div>
      <a
        className="UserApplicationDisplayItem__manage"
        href={`${process.env[getBaseUrl()]}/?account_id=${app.id}`}
      >
        <Icon name="iconExternal" width={12} height={12} />
        <div className="ApplicationDisplayItem__manage--text">
          {t("loginForm.login")}
        </div>
      </a>
    </div>
  );
};
